// infiniteScrollList.js
import React, { useState, useEffect, useRef } from "react";

function InfiniteScrollList({ data, renderItem, initialCount = 10, step = 10 }) {
  const [visibleCount, setVisibleCount] = useState(initialCount);
  const loaderRef = useRef(null);

  // data가 변경되면 visibleCount 초기화
  useEffect(() => {
    setVisibleCount(initialCount);
  }, [data, initialCount]);

  useEffect(() => {
    // 스크롤이 하단 트리거에 닿으면 추가 아이템을 노출한다.
    const observer = new IntersectionObserver(
      (entries) => {
        if (entries[0].isIntersecting && visibleCount < data.length) {
          setVisibleCount((prev) => Math.min(prev + step, data.length));
        }
      },
      {
        root: null,
        rootMargin: "0px",
        threshold: 0.1,
      }
    );
    if (loaderRef.current) {
      observer.observe(loaderRef.current);
    }
    return () => {
      if (loaderRef.current) {
        observer.unobserve(loaderRef.current);
      }
    };
  }, [visibleCount, data, step]);

  return (
    <>
      {data.slice(0, visibleCount).map((item, index) => renderItem(item, index))}
      {visibleCount < data.length && (
        <div ref={loaderRef} style={{ textAlign: "center", padding: "20px" }}>
          Loading...
        </div>
      )}
    </>
  );
}

export default InfiniteScrollList;
